export default "__VITE_ASSET__BCnbcuNI__"